import {TextStyle, ViewStyle} from 'react-native';

export default class TextFrameResourceOptions {
  constructor(
    public containerStyle?: ViewStyle,
    public textStyle?: TextStyle,
    public wideTextStyle?: TextStyle,
    public voiceIconStyle?: ViewStyle,
  ) {}
}
